<script setup lang="ts">
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

// The backend still emits an optional per-cell `ref` ({kind,id}) for linkable
// entities. Profile linking is disabled for now: it would only cover rows the
// query resolved to a profile (the matched/attended ones), not every listed
// name. Re-enable by rendering a <RouterLink :to="{path,query:{from}}"> when
// `cell.ref` is present (see git history / build the path from a fixed route map).
interface CellRef {
  kind: 'participant' | 'trainer' | 'course'
  id: number
  variant?: 'participant' | 'trainer'
}

defineProps<{
  config: {
    headers: { label: string }[]
    rows: { cells: { cell: string | number; ref?: CellRef }[] }[]
  }
}>()
</script>

<template>
  <div class="w-full h-full overflow-auto border rounded-md">
    <Table>
      <TableHeader class="bg-muted">
        <TableRow>
          <TableHead v-for="(header, idx) in config.headers" :key="idx">
            {{ header.label }}
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow v-for="(row, rowIdx) in config.rows" :key="rowIdx">
          <TableCell v-for="(cell, cellIdx) in row.cells" :key="cellIdx">
            {{ cell.cell }}
          </TableCell>
        </TableRow>
        <TableRow v-if="!config.rows || config.rows.length === 0">
          <TableCell :colspan="config.headers.length" class="h-24 text-center">
            No data available.
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </div>
</template>
